// src/components/Contact/Contact.jsx
import React, { useState } from "react";
import { FiMail, FiPhone, FiMapPin, FiSend } from "react-icons/fi";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm, ValidationError } from "@formspree/react";
import "./Contact.css";

const Contact = () => {
  const [state, handleSubmit] = useForm("xdklvjln"); // Formspree ID
  const [captchaValue, setCaptchaValue] = useState(null);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!captchaValue) {
      alert("Please verify you are not a robot.");
      return;
    }
    handleSubmit(e);
  };

  return (
    <section className="contact" id="contact">
      <div className="contact__inner container">
        {/* Info Panel */}
        <address className="contact__info">
          <h3 className="contact__info-title">Get in touch</h3>
          <p className="contact__info-description">
            Have a project in mind or want to discuss potential opportunities?
            Reach out and let's create something amazing together.
          </p>

          <div className="contact__info-items">
            <div className="contact__info-item">
              <div className="contact__icon-container">
                <FiPhone className="contact__icon" />
              </div>
              <div>
                <h4>Phone</h4>
                <p>702-882-4874</p>
              </div>
            </div>

            <div className="contact__info-item">
              <div className="contact__icon-container">
                <FiMail className="contact__icon" />
              </div>
              <div>
                <h4>Email</h4>
                <p>luke@moyerproduction.com</p>
              </div>
            </div>

            <div className="contact__info-item">
              <div className="contact__icon-container">
                <FiMapPin className="contact__icon" />
              </div>
              <div>
                <h4>Location</h4>
                <p>Bonney Lake, Washington</p>
              </div>
            </div>
          </div>
        </address>

        {/* Contact Form */}
        <form className="contact__form" onSubmit={onSubmit} noValidate>
          <h3 className="contact__form-title">Send us a message</h3>

          {/* First & Last Name */}
          <div className="contact__row">
            <label className="contact__input-group">
              <span>First Name *</span>
              <input
                name="firstName"
                value={form.firstName}
                onChange={handleChange}
                required
              />
            </label>

            <label className="contact__input-group">
              <span>Last Name *</span>
              <input
                name="lastName"
                value={form.lastName}
                onChange={handleChange}
                required
              />
            </label>
          </div>

          {/* Email & Subject */}
          <div className="contact__row">
            <label className="contact__input-group">
              <span>Email *</span>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
              <ValidationError prefix="Email" field="email" errors={state.errors} />
            </label>

            <label className="contact__input-group">
              <span>Subject</span>
              <input
                name="subject"
                value={form.subject}
                onChange={handleChange}
              />
            </label>
          </div>

          {/* Message */}
          <label className="contact__input-group contact__message">
            <span>Message *</span>
            <textarea
              name="message"
              rows="6"
              value={form.message}
              onChange={handleChange}
              required
            />
            <ValidationError prefix="Message" field="message" errors={state.errors} />
          </label>

          {/* reCAPTCHA */}
          <div className="contact__recaptcha">
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
              onChange={onCaptchaChange}
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className={`contact__submit ${state.submitting ? "submitting" : ""}`}
            disabled={state.submitting}
          >
            {state.submitting ? "Sending…" : (
              <>
                <FiSend className="contact__submit-icon" />
                Send Message
              </>
            )}
          </button>

          {/* Feedback */}
          {state.succeeded && (
            <p className="contact__success-message">
              … Your message has been sent successfully!
            </p>
          )}
        </form>
      </div>
    </section>
  );
};

export default Contact;

